'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const TabNavigation = () => {
  const currentPath = usePathname();

  const tabs = [
    {
      label: 'Target Strategies',
      href: '/settings/admin/strategy-manager/target',
      isActive: currentPath.startsWith(
        '/settings/admin/strategy-manager/target'
      ),
    },
    {
      label: 'Engage and Expand Strategies',
      href: '/settings/admin/strategy-manager/engage',
      isActive: currentPath.startsWith(
        '/settings/admin/strategy-manager/engage'
      ),
    },
    {
      label: 'Chain Builder',
      href: '/settings/admin/strategy-manager/chain',
      isActive: currentPath.startsWith(
        '/settings/admin/strategy-manager/chain'
      ),
    },
  ];

  return (
    <div className="flex gap-2 border-b border-neutral-200">
      {tabs.map((tab) => (
        <Link
          key={tab.href}
          href={tab.href}
          className={`px-6 py-3 text-sm font-semibold transition-all duration-200 border-b-3 relative ${
            tab.isActive
              ? 'text-sky-600 border-sky-600 bg-sky-50/50'
              : 'text-gray-600 border-transparent hover:text-gray-800 hover:bg-gray-50'
          }`}
        >
          {tab.label}
          {tab.isActive && (
            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-sky-600" />
          )}
        </Link>
      ))}
    </div>
  );
};

export default TabNavigation;
